import { useStaticQuery, graphql } from "gatsby";

export const GetTechnologies = () => {
  const data = useStaticQuery(graphql`
    query {
      allWpService {
        nodes {
          technologiesData {
            nodes {
              technologiesForService {
                nodes {
                  slug
                  title
                }
              }
            }
          }
        }
      }
    }
  `);

  // For each service, extract and flatten technologiesForService
  return data.allWpService.nodes.map(service => {
    const technologiesData = service.technologiesData?.nodes;
    // For each technology in technologiesData, get technologiesForService nodes
    const allTechs = technologiesData?.flatMap(tech =>
      tech.technologiesForService.nodes
    );
    return allTechs;
  });
};
